import { createSlice } from "@reduxjs/toolkit";

export const SystemMsgSlice = createSlice({
    name: "SystemMsgSlice",
    initialState: {
        persistedFormData: {},
    },
    reducers: {
        setPersistedFormData: (state, action) => {
            state.persistedFormData = action.payload
        },
    }
});

export const {
    setPersistedFormData,
} = SystemMsgSlice.actions

export default SystemMsgSlice.reducer
